import React from 'react';
import { Button } from './Button';
export function Footer() {
  return <>
      {/* Final closing CTA */}
      <section className="py-8 md:py-10 px-4 bg-brand-dark border-t border-white/5" data-id="element-61">
        <div className="max-w-2xl mx-auto text-center" data-id="element-62">
          <p className="text-sm md:text-base text-gray-400 mb-2 font-medium" data-id="element-63">
            Hay dos tipos de docentes de Programación.
          </p>
          <h2 className="text-xl md:text-3xl font-extrabold text-white mb-2 leading-tight" data-id="element-64">
            Los que <span className="text-red-400" data-id="element-65">improvisan</span> cada semana
            y pierden sus fines de semana.
          </h2>
          <p className="text-sm md:text-base text-gray-300 mb-4 leading-relaxed" data-id="element-66">
            Y los que tienen un{' '}
            <span className="text-brand-accent font-bold" data-id="element-67">sistema</span>.
          </p>
          <p className="text-sm md:text-base text-gray-300 mb-5 leading-relaxed" data-id="element-68">
            Por <span className="text-white font-bold" data-id="element-69">USD 19,90</span> — menos
            de lo que cuesta una cena — tenés todo lo que necesitás para ser el
            segundo tipo.
          </p>

          <div className="bg-brand-card rounded-3xl border border-brand-accent/30 p-5 mb-4" data-id="element-70">
            <p className="text-xs md:text-sm font-bold text-brand-accent uppercase tracking-wider mb-1" data-id="element-71">
              🏆 Kit Completo
            </p>
            <h3 className="text-lg md:text-xl font-extrabold text-white mb-2 uppercase" data-id="element-72">
              Programación Técnica Lista
            </h3>
            <p className="text-xs md:text-sm text-gray-400 mb-3" data-id="element-73">
              6 tomos + 4 bonos + actualizaciones de por vida
            </p>
            <p className="text-sm text-gray-500 line-through mb-1" data-id="element-74">USD 268</p>
            <p className="text-3xl md:text-4xl font-extrabold text-brand-accent mb-4" data-id="element-75">
              🔥 USD 19,90
            </p>

            <Button href="https://kit-online-2026.myshopify.com/cart/44553745694855:1" className="py-4 text-sm md:text-base" data-id="element-76">
              🚀 → SÍ, QUIERO DEJAR DE IMPROVISAR
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-77">
            <span data-id="element-78">✅ Pago seguro</span>
            <span data-id="element-79">✅ Acceso en 5 min</span>
            <span data-id="element-80">✅ En tu moneda</span>
            <span data-id="element-81">✅ Garantía 7 días</span>
          </div>
        </div>
      </section>

      <footer className="bg-brand-dark text-gray-500 py-5 px-4 border-t border-white/5" data-id="element-82">
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center" data-id="element-83">
          <div className="w-full text-[10px] md:text-xs text-gray-500 font-normal leading-relaxed" data-id="element-84">
            <p data-id="element-85">
              © 2025 Kit Programación Lista — Todos los derechos reservados.
            </p>
            <p className="mt-1" data-id="element-86">
              Material desarrollado por docentes de secundaria técnica para
              docentes de secundaria técnica.
            </p>
          </div>
        </div>
      </footer>
    </>;
}